import {init, configureScope} from '@sentry/react';
import {BrowserTracing} from '@sentry/tracing';

if (['staging', 'live'].includes(import.meta.env.MODE)) {
    init({
        dsn: 'https://7ed408da98b3454d87c2ab17d9fb19a7@o4504485373870080.ingest.sentry.io/4504485425184768',
        integrations: [new BrowserTracing()],
        tracesSampleRate: 0.2,
        environment: import.meta.env.MODE,
    });

    const user = window.SentryUserData ? {...window.SentryUserData} : null;

    if (user) configureScope(scope => scope.setUser(user));
}
